import React from "react";
import { Box, Grid, Paper, Skeleton, Stack } from "@mui/material";

const SKELETON_CARD_COUNT = 4;

const CandidateDashboardListSkeleton = ({
  count = SKELETON_CARD_COUNT,
  showStatusChip = false,
}) => (
  <Grid container spacing={2}>
    {Array.from({ length: count }).map((_, index) => (
      <Grid item xs={12} key={index}>
        <Paper
          elevation={0}
          sx={{
            borderRadius: "8px",
            p: 1.5,
            bgcolor: "#fff",
            border: "1px solid rgba(0, 0, 0, 0.06)",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.08)",
          }}
        >
          <Grid container alignItems="center" spacing={1.5}>
            <Grid item xs={3} md={2} display="flex" justifyContent="center">
              <Skeleton
                variant="circular"
                width={48}
                height={48}
                animation="wave"
              />
            </Grid>
            <Grid item xs={9} md={10}>
              <Stack spacing={0.75}>
                <Skeleton
                  variant="rounded"
                  width="68%"
                  height={18}
                  animation="wave"
                  sx={{ borderRadius: "4px" }}
                />
                <Skeleton
                  variant="rounded"
                  width="42%"
                  height={14}
                  animation="wave"
                  sx={{ borderRadius: "4px" }}
                />
                <Skeleton
                  variant="rounded"
                  width="100%"
                  height={1}
                  animation="wave"
                  sx={{ my: 0.75, borderRadius: 0 }}
                />
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                  <Skeleton
                    variant="rounded"
                    width={showStatusChip ? "48%" : "55%"}
                    height={13}
                    animation="wave"
                    sx={{ borderRadius: "4px" }}
                  />
                  {showStatusChip && (
                    <Skeleton
                      variant="rounded"
                      width={76}
                      height={26}
                      animation="wave"
                      sx={{ borderRadius: "4px", flexShrink: 0 }}
                    />
                  )}
                </Box>
              </Stack>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    ))}
  </Grid>
);

export default CandidateDashboardListSkeleton;
